import React, { useState } from 'react';
import { Headphones, Calendar, Mic, FileText } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const Listen = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');

  const handleNotifyMe = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: "Thank you!",
        description: "We'll notify you when the audiobook is available.",
      });
      setEmail('');
    }
  };

  return (
    <section id="listen" className="listen-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Listen / Get the Audiobook</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="listen-content">
          <div className="listen-info">
            <div className="info-grid">
              <div className="info-item">
                <Headphones size={32} />
                <div>
                  <h4 className="heading-6">Format</h4>
                  <p className="body-small">AI-narrated Audiobook</p>
                </div>
              </div>
              
              <div className="info-item">
                <Calendar size={32} />
                <div>
                  <h4 className="heading-6">Release Date</h4>
                  <p className="body-small">May 25, 2025</p>
                </div>
              </div>
              
              <div className="info-item">
                <FileText size={32} />
                <div>
                  <h4 className="heading-6">Genres</h4>
                  <p className="body-small">Self-help, Psychology, Science & Technology</p>
                </div>
              </div>
              
              <div className="info-item">
                <Mic size={32} />
                <div>
                  <h4 className="heading-6">Author</h4>
                  <p className="body-small">Daniel A. Stoescu</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="listen-cta">
            <div className="cta-card">
              <h3 className="heading-4">Listen Now</h3>
              <p className="body-medium">
                Available now on multiple platforms. Experience the full audiobook and discover practical tools for mental resilience.
              </p>
              
              <div className="platform-buttons">
                <a 
                  href="https://www.barnesandnoble.com/w/mental-and-emotional-health-in-todays-hybrid-warfare-environment-daniel-a-stoescu/1147504161"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn"
                >
                  Barnes & Noble
                </a>
                
                <a 
                  href="https://open.spotify.com/show/6PwTbTlzIzqgCEPuLnySZk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn spotify-btn"
                >
                  Spotify
                </a>
                
                <a 
                  href="https://play.google.com/store/audiobooks/details/Mental_and_Emotional_Health_in_today_s_Hybrid_Warf?id=AQAAAEDKhD3E5M&hl=en_US"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn google-play-btn"
                >
                  Google Play
                </a>
                
                <a 
                  href="https://www.audiobooks.com/audiobook/mental-and-emotional-health-in-todays-hybrid-warfare-environment/924417?srsltid=AfmBOorxR2jF7t3_gWrB27cS1qjli636kKOqJN5PYGihbRBrVRCyYZLq"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn audiobooks-btn"
                >
                  Audiobooks.com
                </a>
                
                <a 
                  href="https://books.apple.com/no/audiobook/mental-and-emotional-health-in-todays-hybrid-warfare/id1819536776?l=nb"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn apple-books-btn"
                >
                  Apple Books
                </a>
                
                <a 
                  href="https://www.everand.com/author/869060696/Daniel-A-Stoescu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn everand-btn"
                  data-testid="listen-everand-btn"
                >
                  Everand
                </a>
                
                <a 
                  href="https://libro.fm/audiobooks/9798347365982-mental-and-emotional-health-in-today-s-hybrid-warfare-environment"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn librofm-btn"
                  data-testid="listen-librofm-btn"
                >
                  Libro.fm
                </a>
                
                <a 
                  href="https://www.kobo.com/au/en/audiobook/mental-and-emotional-health-in-today-s-hybrid-warfare-environment"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary platform-btn kobo-btn"
                  data-testid="listen-kobo-btn"
                >
                  Kobo
                </a>
              </div>
              
              <div className="notify-divider">
                <span className="caption">Get notified about new platforms</span>
              </div>
              
              <form onSubmit={handleNotifyMe} className="notify-form">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="email-input"
                  required
                />
                <button type="submit" className="btn-secondary">
                  Notify Me
                </button>
              </form>
              
              <p className="caption">
                We'll send you updates when the audiobook becomes available on additional platforms
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Listen;
